module.exports = __webpack_public_path__ + "static/media/Jazzmansdaucropped.965641d7.jpg";